import { apiRequest } from '../index';
import { MEDICAL_SPECIALTIES_URL } from '../urls';
import { Filters } from 'src/props/filters.props';
import { CacheManager } from 'src/services/cache';

export const list = async (filters: Filters) => {
  const cacheMgr = new CacheManager();
  await cacheMgr.init('specialties-cache', 30);

  const url = MEDICAL_SPECIALTIES_URL;
  const response = await cacheMgr.getCache(url, 'json');

  if (response) {
    return { data: response };
  }

  const data = apiRequest('GET', MEDICAL_SPECIALTIES_URL, null, filters);
  data.then((res) => {
    cacheMgr.setCache(url, res, 'json');
  });

  return data;
};

export default {
  list,
};
